import { getRbacService } from "@ntconnect/framework/pbx";

export const fetchGroups = (domain, page, pageSize, search, filter) =>
  getRbacService().fetchGroups(domain, page, pageSize, search);

export const fetchGroupsForUser = (domain, userId, page, pageSize, search, filter) =>
  getRbacService().fetchGroupsForUser(domain, userId, page, pageSize, search);

export const fetchPermissions = (domain, userId, page, pageSize, search, filter) =>
  getRbacService().fetchPermissions(domain, userId, page, pageSize, search);

export const fetchPermissionsForGroup = (domain, groupId, page, pageSize, search, filter) =>
  getRbacService().fetchPermissionsForGroup(domain, groupId, page, pageSize, search);

export const addGroupToUser = (domain, userId, groupId) =>
  getRbacService().addGroupToUser(domain, userId, groupId);

export const deleteGroupFromUser = (domain, userId, groupId) =>
  getRbacService().deleteGroupFromUser(domain, userId, groupId);
